/**
 * Icono de pestaña (favicon) y apple-touch-icon.
 * El HTML estático usa Menuee; en runtime se reemplaza por sucursal.logo_url.
 */

const SELECTOR_ICON = 'link[rel="icon"]';
const SELECTOR_APPLE = 'link[rel="apple-touch-icon"]';

function asegurarLink(selector, rel) {
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  return el;
}

/**
 * @param {string|null|undefined} url
 */
export function aplicarIconoDocumento(url) {
  if (typeof document === "undefined") {
    return;
  }

  const href = String(url || "").trim();
  if (!href) {
    return;
  }

  asegurarLink(SELECTOR_ICON, "icon").setAttribute("href", href);
  asegurarLink(SELECTOR_APPLE, "apple-touch-icon").setAttribute("href", href);
}
